import React from "react";

export default function StripePopup({ message, onClose }) {
  return (
    <div className="popup-wrapper" onClick={onClose}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <div className="popup-header">
          <span>Stripe Payment</span>
          <button className="popup-close" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="popup-body">
          <p>{message}</p>
        </div>
      </div>
    </div>
  );
}
